import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { options, subTraitDetails,colors } from '../../data/DISC/subTraits.js'
import Alert from 'react-bootstrap/Alert';
import { Container } from 'react-bootstrap';

function SubtraitsGuide() {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row className='align-items-center'>
                <figure className="text-center" style={{ color: 'black' }}>
                    <blockquote className="blockquote">
                        <h2><b>Personal Guide</b></h2>
                    </blockquote>
                    <figcaption className="blockquote-footer " style={{fontSize:'17px'}}>
                        A majority of the population exhibits more than one DiSC type
                    </figcaption>
                </figure>
                <Col sm={2}>
                    <ListGroup className=''>
                        {options.map((option, index) => (
                            <ListGroup.Item key={index} action href={`#link${index + 1}`} style={{ textAlign: 'center', backgroundColor:colors[index],fontWeight:'bold' }}>
                                {option}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Col>
                <Col>
                    <Container className='card py-4'>
                        <Tab.Content>
                            {subTraitDetails.map((item, index) => (
                                <Tab.Pane key={index} eventKey={`#link${index + 1}`}>
                                    <h4><b>{item.head}</b></h4>
                                    <Row>
                                        <Col><p>{item.body1}</p></Col>
                                        {item.body2 && <Col><p>{item.body2}</p></Col>}
                                    </Row>
                                    
                                    <p><b>Traits : </b>{item.qualities.traits}</p>
                                    <p><b>Aspirations : </b>{item.qualities.goals}</p>
                                    <p><b>Worries : </b> {item.qualities.fears}</p>
                                    <p><b>Anticipate : </b>{item.qualities.anticipate}</p>
                                    <p><b>Influences others by : </b>{item.qualities.influence}</p>
                                    <p><b>In conflict : </b>{item.qualities.conflict}</p>
                                    <p><b>Can build on : </b>{item.qualities.improve}</p>
                                    <Alert variant='success'>
                                        <p><b>Leadership qualities : </b>{item.qualities.leadership}</p>
                                    </Alert>
                                </Tab.Pane> 
                                ))
                            }
                        </Tab.Content>
                    </Container>
                </Col>
            </Row>
        </Tab.Container>
    );
}

export default SubtraitsGuide;
